import { Alert, IconAttention, styled } from '@payright/web-components';
import { useRef, useEffect, ReactElement } from 'react';

type AlertSliceErrorProps = {
  slice: {
    hasErrors: boolean;
    errorMessage?: ReactElement | string | null;
    errorTitle?: string | null;
  };
};

const SCAlertDiv = styled.div`
  margin-top: 2rem;
`;

export const AlertSliceError = ({
  slice: { hasErrors, errorMessage, errorTitle },
}: AlertSliceErrorProps) => {
  const mainBlockRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (hasErrors && typeof mainBlockRef?.current?.scrollIntoView === 'function') {
      mainBlockRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [hasErrors, mainBlockRef]);
  return (
    <>
      {hasErrors && (errorTitle || errorMessage) && (
        <SCAlertDiv>
          <div ref={mainBlockRef} style={{ position: 'relative', top: '-2em' }}></div>
          <Alert
            title={errorTitle || ''}
            body={errorMessage || ''}
            outcome="error"
            icon={<IconAttention />}
          />
        </SCAlertDiv>
      )}
    </>
  );
};
